import { render } from "./config-list-table.vue?vue&type=template&id=612f107d&ts=true"
import script from "./config-list-table.ts?vue&type=script&lang=ts"
export * from "./config-list-table.ts?vue&type=script&lang=ts"

import "./config-list-table.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__